import React, { useState, useEffect } from "react";
import "./SapMMLearningCards.css";

const SapMMLearningCards = () => {
 return (
  <div className="sapmm-container">
   <h2>Phases of SAP MM</h2>
   <div className="sapmm-wrapper">
    <div className="sapmm-row " tabIndex={0}>
     <div className="sap-img-row row1">
      <img src="images/SapMM/Cards/sapmm-card1.png" alt="sapmm-card" />
      <h4>
       <span>Master Data</span>
      </h4>
     </div>
     <div className="card-content card1">
      <p>
       Data that is created centrally and provides context for business transactions and
       operations.
      </p>
      {/* <div>Coming Soon...</div> */}
      <div className="sap-click card1">Coming Soon...</div>

      {/* <div className="sap-click card1">Click here</div> */}
     </div>
    </div>
    <div className="sapmm-row" tabIndex={0}>
     <div className="sap-img-row row2">
      <img src="images/SapMM/Cards/sapmm-card2.png" alt="sapmm-card" />
      <h4>
       <span>P2P Process</span>
      </h4>
     </div>
     <div className="card-content card2">
      <p>
       P2P, procure-to-pay is the process of requisitioning, purchasing, receiving, paying
       for, and accounting for goods and services, covering the entire process from point
       of order right through to payment.
      </p>
      <div className="sap-click card1">Coming Soon...</div>

      {/* <div className="sap-click">Click here</div> */}
     </div>
    </div>
    <div className="sapmm-row" tabIndex={0}>
     <div className="sap-img-row row3">
      <img src="images/SapMM/Cards/sapmm-card3.png" alt="sapmm-card" />
      <h4>
       <span>Sub Contracting</span>
      </h4>
     </div>
     <div className="card-content card3">
      <p>
       In subcontracting process, raw materials are provided to subcontracting vendor.
       It's being processed by subcontracting vendor, convert it to semi-finish/finished
       material and deliver back.
      </p>
      <div className="sap-click card1">Coming Soon...</div>

      {/* <div className="sap-click">Click here</div> */}
     </div>
    </div>
    <div className="sapmm-row" tabIndex={0}>
     <div className="sap-img-row row4">
      <img src="images/SapMM/Cards/sapmm-card4.png" alt="sapmm-card" />
      <h4>
       <span>Supply Process</span>
      </h4>
     </div>
     <div className="card-content card4">
      <p>
       In supply process system automatically assigning SP based on predefined rules it
       allows the channeling of material requests to the correct source without manual
       user decisions.
      </p>
      {/* <a className='sap-click'  target="_blank" href='https://myoffice.accenture.com/personal/uma_rani_battu_accenture_com/_layouts/15/Doc.aspx?sourcedoc={52a4df89-61d6-4443-b289-d5a76bc8b0cd}&amp;action=embedview&amp;wdAr=1.7777777777777777'>Click here</a> */}
      <div className="sap-click">Coming Soon...</div>

      {/* <div className='sap-click'>Click here</div> */}
      {/* <DocViewer pluginRenderers={DocViewerRenderers} documents={docs} /> */}
     </div>
    </div>
   </div>
   {/* <a target="_blank" href='https://myoffice.accenture.com/personal/uma_rani_battu_accenture_com/_layouts/15/Doc.aspx?sourcedoc={52a4df89-61d6-4443-b289-d5a76bc8b0cd}&amp;action=embedview&amp;wdAr=1.7777777777777777'>Click here</a> */}
   {/* {activeAccount.idTokenClaims.enterpriseID ==="uma.rani.battu"?
      <iframe src="https://myoffice.accenture.com/personal/uma_rani_battu_accenture_com/_layouts/15/Doc.aspx?sourcedoc={52a4df89-61d6-4443-b289-d5a76bc8b0cd}&amp;action=embedview&amp;wdAr=1.7777777777777777" width="476px" height="288px" frameborder="0">This is an embedded <a target="_blank" href="https://office.com">Microsoft Office</a> presentation, powered by <a target="_blank" href="https://office.com/webapps">Office</a>.</iframe>      :activeAccount.idTokenClaims.enterpriseID ==="ankur.e.mishra"?
      <iframe src='https://myoffice.accenture.com/:p:/r/personal/uma_rani_battu_accenture_com/_layouts/15/Doc.aspx?sourcedoc=%7B52a4df89-61d6-4443-b289-d5a76bc8b0cd%7D&amp=&action=embedview&wdAr=1.7777777777777777' height={400} width={300}/>:
      ""} */}
  </div>
 );
};

export default SapMMLearningCards;
